import { parse } from 'querystring';
import pathRegexp from 'path-to-regexp';
import { message } from 'antd';
import type { Route } from '@/models/connect';
import md5 from 'md5';
import qs from 'qs';
import type { LqMenuItem } from '@/store/user';
import { DATA, LQ_DEV, menu_type_button, menu_type_endpoint, MenuType } from '@/constant';
import type { PaginatedParams } from 'ahooks/lib/useAntdTable';

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const isAntDesignPro = (): boolean => {
  if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return true;
  }
  return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    return true;
  }
  return isAntDesignPro();
};

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */
export const getAuthorityFromRouter = <T extends Route>(
  router: T[] = [],
  pathname: string,
): T | undefined => {

  const authority = router.find(
    ({ routes, path = '/', target = '_self' }) =>
      (path && target !== '_blank' && pathRegexp(path).exec(pathname)) ||
      (routes && getAuthorityFromRouter(routes, pathname)),
  );
  if (authority) return authority;
  return undefined;
};


export const getAuthorityFromRouter2 = (path: string, routeData: any) => {
  let authorities: string[] | string | undefined;
  routeData.forEach((route: any) => {
    // match prefix
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority;
      }
      // exact match
      if (route.path === path) {
        authorities = route.authority || authorities;
      }
      // get children authority recursively
      if (route.routes) {
        authorities = getAuthorityFromRouter2(path, route.routes) || authorities;
      }
    }
  });
  return authorities;
};




export const getRouteAuthority = (path: string, routeData: Route[]) => {
  let authorities: string[] | string | undefined;
  routeData.forEach((route) => {
    // match prefix
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority;
      }
      // exact match
      if (route.path === path) {
        authorities = route.authority || authorities;
      }
      // get children authority recursively
      if (route.routes) {
        authorities = getRouteAuthority(path, route.routes) || authorities;
      }
    }
  });
  return authorities;
};


export const lenValidator = ({ start, end, label }: { start: number, end: number, label: string }) => {
  const validator = (rule: any, value: string) => {
    const len = value.length;
    if (!value || (len >= start && len <= end)) {
      return Promise.resolve();
    }
    const error = new Error();
    error.message = `${label}长度限定于1-30`
    return Promise.reject(error);
  }

  return validator
}


/**
 *
 * @param value
 * @returns boolean 是否为数字符号字符串
 */
export const isNumberSignStr = (value: string) => /^[0-9|\-|a-z|A-Z]*$/ig.test(value);

/**
 * 判断是否是数字字符串的正则
 */
export const isNumberStr = /^[0-9]*$/ig;

export type GetParamsProps = {
  idKey: string;
  nameKey: string
}

/**
 *
 * @param searchContent  搜索内容
 * @param obj // {idKey,nameKey}{idkey值,namekey值}
 * @returns  // {idKey:searchContent} or {namekey:searchContent}
 */
export const getParams = (searchContent: string, { idKey, nameKey }: GetParamsProps) => {
  if (isNumberSignStr(searchContent)) {
    return { [idKey]: searchContent };
  }
  return { [nameKey]: searchContent };
}


export const changeObjValue = (targetobj: any, paramsObj: any) => {
  const newObject = new Proxy(targetobj, {
    get: (target, key) => {
      if (key in paramsObj) {
        return target[paramsObj[key]]
      }
      return target[key]
    }
  })

  return newObject
}


/**
 * file字段数组
 */
const files = ['file', 'iconFile', 'signFile', 'plistFile'];

/**
 *
 * @param param 参数
 * @returns 排序好的参数
 */
const sortASCII = (param: any) => {
  const keys = [];
  for (const k of param.keys()) {
    keys.push(k);
  }
  // 排序
  keys.sort();
  // 转成json
  const kv = {};
  keys.forEach((k: string) => {
    if (files.indexOf(k) === -1) {
      kv[k] = param.get(k).replace(/\r\n/g, '').replace(/\n/g, '');
      kv[k] = kv[k].replaceAll('\\n', '').replaceAll('\\r', '')
    }
  });
  return kv
}


/**
 * 加密函数
 * @param option // 参数
 * @returns 返回带sign（签名）的参数
 */
const getSign = (option: any) => {
  // console.log(JSON.stringify(sortASCII(option))

  return md5(JSON.stringify(sortASCII(option))).toUpperCase();
}

type Params = { key: string, category?: string, value: any }

/**
 * @param arr1 定义
 * @param arr2 值


 */
export const mergeParamValue = (arr1: Params[] = [], arr2: Params[] = []) => {

  return arr1.map((item) => {
    const exist = arr2.find(el => el.key === item.key && el?.category === item?.category)

    if (exist) {
      return { ...item, ...exist }
    }
    return item


  })
};



export const mergeChosedParams = (chosedArr: any[], arr: any[]) => {
  return arr.map((item) => {
    const exist = chosedArr.find(el => el.key === item.key)

    if (exist) {
      return { ...item, ...exist }
    }
    return { ...item, value: 0 }
  }).sort((a: any, b: any) => b.value - a.value)
}


export const mergeParams = (arr1: any[] = [], arr2: any[] = []) => {
  const result: any[] = [];
  arr1.forEach((val1) => {
    const val2 = arr2.find((val) => val.key === val1.key);
    if (val2) {
      result.push({ ...val1, ...val2 });
    } else {
      result.push(val1);
    }
  });
  arr2.forEach((val2) => {
    const val1 = arr1.find((val) => val.key === val2.key);
    if (!val1) {
      result.push(val2);
    }
  });
  return result;
};

/**
 * 对数组参数做处理
 * @param formdata // formdata对象
 * @param key
 * @param value
 */
const appendArr = (formdata: any, key: any, value: any) => {
  if (!value.length) {
    return
  }
  const str = qs.stringify({ [key]: value }, {
    allowDots: true,
    // encode: false,
    encodeValuesOnly: true,
    encoder: (strVal) => {
      return encodeURIComponent(strVal);
    }
  });
  const strList = str.split('&');
  strList.forEach(el => {
    const [formKey, formValue] = el.split('=');
    formdata.append(formKey, decodeURIComponent(formValue))
  })
}




/**
 * 获取formdata
 * @param data // 提交参数
 * @returns // 返回加入sign（签名）的参数
 */
export const getFormData = (data: any) => {
  const body: any = { ...data, timestamp: `${Math.round(Date.now() / 1000)}`, sToken: localStorage.getItem('sToken') || "" };
  const formdata = new FormData();
  Object.keys(body).forEach((key: string) => {
    if (Object.prototype.toString.call(body[key]) === "[object String]") {
      body[key] = body[key].trim()
    }
    if (body[key] instanceof Array) {

      appendArr(formdata, key, body[key])
    } else if (files.indexOf(key) >= 0 && !(body[key] instanceof Blob)) {
      // formdata.append(key,body[key]);
    }
    else {
      formdata.append(key, (body[key] === undefined || body[key] === null) ? "" : body[key]);
    }

  });
  formdata.append("sign", getSign(formdata));
  return formdata
}



export const getData = (data: Record<string, unknown>) => {

  const body: any = { ...data, timestamp: `${Math.round(Date.now() / 1000)}`, sToken: localStorage.getItem('sToken') || "" };
  const formdata = new FormData();
  Object.keys(body).forEach((key: string) => {
    if (Object.prototype.toString.call(body[key]) === "[object String]") {
      body[key] = body[key].trim()
    }
    if (body[key] instanceof Array) {

      appendArr(formdata, key, body[key])
    }
    else {
      formdata.append(key, (body[key] === undefined || body[key] === null) ? "" : body[key]);
    }
  });
  return formdata
}



/**
 * 获取number类型组件参数验证函数
 */
export const getNumberValidator = (num: number) => {
  return {
    validator: (rule: any, value: any, callback: any) => {
      const targetVal = `${value}`;
      if (targetVal.length > num) {
        callback(`位数不能大于${num}`)
      }
      callback();
    }
  }
}

export const defaultNumberValidator = getNumberValidator(10);



/**
 * 排序配置
 */
export const sorterConfig = {
  sorter: {
    compare: (cur: any, pre: any) => cur.id - pre.id
  }
}
/**
 * 自定义排序id
 */
export const sorterOtherId = (id: string) => {
  return {
    sorter: {
      compare: (cur: any, pre: any) => cur[id] - pre[id]
    }
  }
}


/**
 * 文件大小限制
 * @param file 文件对象
 * @size 限制大小 单位M
 */
export const sizeLimit = (file: any, size = 800) => {
  const maxSize = size * 1024 * 1024;
  if (file.size > maxSize) {
    message.warning(`文件大小不能超${size}M`);
    return true;
  }
  return false;
}

/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {cb}
 */
function getBlob(url: any) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };

    xhr.send();
  });
}

/**
* 保存
* @param  {Blob} blob
* @param  {String} filename 想要保存的文件名称
*/
let isDownloading = false;
function saveAs(blob: any, filename: any) {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = function (e) {
    const link = document.createElement('a');
    const body: any = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.setAttribute('target', "_blank");

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  };
  message.destroy()
  message.success(`加载完成`);
  isDownloading = false;
}


/**
* 下载
* @param  {String} url 目标文件地址
* @param  {String} filename 想要保存的文件名称
*/
export function downloadFile(url: any, filename: any) {
  if (isDownloading) return;
  message.destroy()
  message.warning(`正在加载......`, 0);
  isDownloading = true;
  getBlob(url).then(blob => {
    saveAs(blob, filename);
  });
};
/**
* 下载
* @param  {String} url 目标文件地址
* @param  {String} filename 想要保存的文件名称
*/
export function downloadMuFile(url: any, filename: any) {
  message.warning(`正在加载......`, 0);
  getBlob(url).then(blob => {
    saveAs(blob, filename);
  });
};

export function downloadFie(url: any, filename: any) {
  const link = document.createElement('a');
  const body: any = document.querySelector('body');

  link.href = url;
  link.download = filename;
  link.setAttribute('target', "_blank");

  // fix Firefox
  link.style.display = 'none';
  body.appendChild(link);

  link.click();
  body.removeChild(link);
};
/**
* 自定义排序id
*/
export const getCode = (str: string) => {
  return str.match(/[^{\}]+(?=})/g)
}
/**
* 复制字符串
*/
export const copyStr = (str: string) => {
  const aux = document.createElement('input')
  aux.setAttribute('value', str)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
}



/**
 * 过滤对象中的null和undefined 属性
 * @param obj 
 * @returns 
 */
export function filterEmptyObject<T extends Record<string, any>>(obj: T) {

  const temp: Record<string, any> = {};

  Object.keys(obj).forEach(el => {
    if (obj[el] !== null && obj[el] !== undefined) {
      temp[el] = obj[el]
    }
  })

  return temp

}



/**
 * 判断是否在国内
 * @returns boolean
 */
export function isInternal() {
  return process.env.LQ_ENV ? process.env.LQ_ENV === 'internal' : true
}


/**
 * 判断是否测试环境
 * @returns boolean
 */
export function isTestDev() {
  return process.env.LQ_DEV ? process.env.LQ_DEV === LQ_DEV : true
}


const regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig //eslint-disable-line


/** emoji文本过滤 */
export const emojiReplace = (val: string) => val.replace(regStr, '');



export const getMenuTreeList = (list: any[]) => {

  if (!list) return []

  const menuObj: Record<string, any> = {};

  const _list = list.map((el: any) => {
    const temp = { ...el };
    menuObj[el.id] = temp;
    return temp
  })



  const resList: any = [];
  _list.forEach((item: any) => {
    item.title = item.name;
    item.value = item.id;
    item.key = item.id;
    if (menuObj[item.parentId] && menuObj[item.parentId] != '0') {
      if (!menuObj[item.parentId].children) {
        menuObj[item.parentId].children = [];
      }
      menuObj[item.parentId].children.push(item);
    } else {
      resList.push(item)
    }

  });
  return resList
}

export const HeadMenu = {
  id: '0',
  parentId: '0',
  name: "根菜单",
  type: 'menu',
  key: '0',
  value: '0',
  title: '根菜单'
}


export const getTreeData = (list: any[]) => {
  return [
    HeadMenu,
    ...list
  ]

}


export const createMenuItem = (item: LqMenuItem) => {
  return {
    ...item,
    key: item.uri,
    path: item.uri,
  }
}


export const createTreeItem = (item: LqMenuItem) => {
  return {
    ...item,
    title: item.name || item.id,
    label: item.name || item.id,
    value: item.id,
    key: item.id,
  }
}





export const getTreeDataInfo = (list: LqMenuItem[], createItem: typeof createMenuItem | typeof createTreeItem = createTreeItem) => {

  if (!list) return {
    list: [],
    mapData: {}
  }

  const menuObj: Record<string, LqMenuItem> = {};

  const temp_list = list.map((el) => {
    const temp = createItem({ ...el });
    menuObj[el.id] = temp;
    return temp
  })

  const resList: LqMenuItem[] = [];
  temp_list.forEach((item) => {
    if (menuObj[item.parentId]) {
      if (!menuObj[item.parentId].children) {
        menuObj[item.parentId].children = [];
      }
      menuObj[item.parentId].children!.push(item);
      menuObj[item.parentId].children?.sort((a, b) => a.sortNumber - b.sortNumber)
    } else {
      resList.push(item)
    }
  });



  return {
    list: resList.sort((a, b) => a.sortNumber - b.sortNumber),
    mapData: menuObj
  }
}


export const findFirstPagePath = (pageList: LqMenuItem[]): string => {
  if (!pageList.length) {
    return ''
  }
  if (pageList[0] && pageList[0].children) {
    return findFirstPagePath(pageList[0].children)
  }
  return pageList[0].uri
}


/**
 * 获取菜单
 * @param id 
 * @param resourceList 
 * @param sysResourceList 
 * @returns 
 */
export const getMenu = (id: string, resourceList: LqMenuItem[], sysResourceList: LqMenuItem[], hideMenuList: string[] = []) => {
  if (id === undefined || id === null) {
    return []
  }
  const user_resourceList = resourceList;
  const sys_resourceList_uri = sysResourceList.map((el: any) => el.uri);
  const filterList = user_resourceList
    .filter((el: any) => {
      return el.type !== menu_type_button && el.type !== menu_type_endpoint
    })
    .filter((el: any) => {
      if (hideMenuList.length) {
        return !hideMenuList.includes(el.uri)
      }
      return true
    })
    .filter((el: any) => el.gameId == id || el.gameId == 0)
    .filter((el: any) => !sys_resourceList_uri.includes(el.uri))
    .filter((el: any) => el.uri);




  const map: any = {};
  filterList.forEach((el: any) => {
    map[el.uri] = el;
  })

  const { list } = getTreeDataInfo(Object.values(map), createMenuItem);
  return list
}

/**
 * 处理useAntdTable 请求参数
 * @param param0 分页数据
 * @param props 表单数据
 * @returns 
 */
export const dealPageParms = ({ current, pageSize }: PaginatedParams[0], props: Record<string, any>) => {

  return {
    current,
    size: pageSize,
    [DATA]: props
  }
}


export const SwitchFormConfig = {
  valuePropName: 'checked',
  getValueProps: (value: string | undefined) => {

    console.log('value', value)
    return {
      checked: !(!value || value === '0'),
    }
  },
  getValueFromEvent: (e: undefined | boolean) => (e ? '1' : '0'),
};

export const getDeepObject = (obj: Record<string, any>, arr: (string | number)[] | string | number) => {
  if (typeof arr === 'string' || typeof arr === 'number') {
    return obj[arr];
  }

  let temp;
  for (let index = 0; index < arr.length; index++) {
    const key = arr[index];
    try {
      if (!temp) {
        temp = obj[key];
      } else {
        temp = temp[key];
      }
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }
  return temp;
};

/**
 * form.item 中判断对应属性是否更新
 * @param prevValues shouUpdate中的prevValues
 * @param currentValues shouUpdate中的currentValues
 * @param stateList 对应属性列表
 * @returns 对应属性列表中是否有属性更新
 */
export const isStateChange = (
  prevValues: any,
  currentValues: any,
  stateList: (string | string[] | (string | number)[] | number)[],
): boolean => {
  const jude = stateList.some(el => {
    if (getDeepObject(prevValues, el) !== getDeepObject(currentValues, el)) {
      return true;
    }
  });
  return jude;
};